import React, { useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import ReactMarkdown from 'react-markdown';

const Newsletter = ({
	button,
	placeholder,
	smallprint,
	nameBoolean,
	namePlaceholder,
	onSuccess,
	tagId,
	tagName,
}) => {
	const [isSuccess, setSuccess] = useState(false);
	const [isError, setError] = useState(false);
	const [isSubmitting, setSubmitting] = useState(false);
	const [message, setMessage] = useState('');

	const trackNewsletterSignup = () => {
		if (typeof window === 'undefined') return;
		if (typeof window.gtag !== 'function') return;

		window.gtag('event', 'newsletter_signup', {
			newsletter_tag_id: tagId || '',
			newsletter_tag_name: tagName || '',
			page_path: window.location?.pathname || '',
		});
	};

	const submitNewsletterSignup = async (values) => {
		const res = await fetch('/api/subscribe', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				email: values.email,
				name: values.name || null,
				tagId: tagId || null,
				tagName: tagName || '',
			}),
		});

		const data = await res.json();

		if (data.success) {
			setError(false);
			setSuccess(true);
			trackNewsletterSignup();
			if (onSuccess) onSuccess();
			setMessage('Thanks for Signing Up!');
		} else {
			setError(true);
			setSuccess(false);
			console.error('Error: ' + (data.error || 'Something went wrong'));
		}
	};

	return (
		<div
			className={`newsletter ${isSuccess ? 'success-true' : ''} ${
				isError ? 'error-true' : ''
			}`}
		>
			<Formik
				initialValues={{
					email: '',
					name: '',
					gdpr: false,
				}}
				validate={(values) => {
					const errors = {};

					if (!values.email) {
						errors.email = 'required';
					} else if (
						!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
							values.email,
						)
					) {
						errors.email = 'Invalid Email Address';
					}

					if (nameBoolean && !values.name) {
						errors.name = 'required';
					}

					if (!values.gdpr) {
						errors.gdpr = 'required';
					}

					return errors;
				}}
				onSubmit={(values) => {
					setSubmitting(true);
					setTimeout(() => submitNewsletterSignup(values), 300);
				}}
			>
				{() => (
					<Form data-tag-id={tagId}>
						<div className='form-container'>
							{!nameBoolean && (
								<div className='field-container signup-container'>
									<Field
										className='input-title'
										type='email'
										name='email'
										placeholder={placeholder}
									/>
									<ErrorMessage
										name='email'
										component='span'
										className='error'
									/>

									<button
										className='btn btn--large'
										type='submit'
										disabled={isSubmitting}
									>
										<span className='btn-text'>
											{button}
										</span>
									</button>
								</div>
							)}
							{nameBoolean && (
								<>
									<div className='field-container'>
										<Field
											className='input-title'
											type='text'
											name='name'
											placeholder={namePlaceholder}
										/>
										<ErrorMessage
											name='name'
											component='span'
											className='error'
										/>
									</div>

									<div className='field-container'>
										<Field
											className='input-title'
											type='email'
											name='email'
											placeholder={placeholder}
										/>
										<ErrorMessage
											name='email'
											component='span'
											className='error'
										/>
									</div>

									<button
										className='btn btn--large'
										type='submit'
										disabled={isSubmitting}
									>
										<span className='btn-text'>
											{button}
										</span>
									</button>
								</>
							)}

							{/* GDPR Checkbox (always shown) */}
							<label className='field-container checkbox'>
								<Field type='checkbox' name='gdpr' />
								<div className='checkbox_indicator'></div>
								<div className='small-print'>
									<ReactMarkdown>{smallprint}</ReactMarkdown>
								</div>
								<ErrorMessage
									name='gdpr'
									component='span'
									className='error'
								/>
							</label>
						</div>
					</Form>
				)}
			</Formik>

			<div
				className={`return-message ${isSuccess ? 'is-success' : ''} ${
					isError ? 'is-error' : ''
				}`}
			>
				<div className='message message-success'>
					<h4>Thanks for signing up!</h4>
				</div>
				<div className='message message-error'>
					<h4>Woops! Looks like there was a problem... {message}</h4>
				</div>
			</div>
		</div>
	);
};

export default Newsletter;
